import React, { useCallback, useEffect } from "react";

import { Typography } from "@material-ui/core";

import { useDispatch, useSelector } from "react-redux";

import Navigation from "../Navigation";
import { DashboardState } from "../reducers/dashboard";
import { fetchDashboardData } from "../actions/dashboard";
import { SetupNewWarehouseList } from "./SetupNewWarehouseList";
import { DashboardPage } from "./DashboardPage";
import useOnEnvironmentSet from "../hooks/on-environment-set";

const DashboardPageHeader: React.FC = () => {
  const { data: dashboardData, loading } = useSelector(
    (state: { dashboard: DashboardState }) => state.dashboard
  );

  if (loading) {
    return null;
  }

  return (
    <>
      <Typography component="h2" gutterBottom variant="overline">
        Destinations
      </Typography>
      <Typography component="h1" gutterBottom variant="h3">
        {dashboardData.length > 0
          ? "Connected Warehouses"
          : "Retroactively send data to your warehouse with one click, no ETL required."}
      </Typography>
    </>
  );
};

const WarehousesPage: React.FC = () => {
  const dispatch = useDispatch();

  const initializeDashboard = useCallback(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  useOnEnvironmentSet(() => {
    initializeDashboard();
  });

  useEffect(() => {
    const timer = setInterval(() => {
      initializeDashboard();
    }, 1000 * 60 * 30);

    return () => clearInterval(timer);
  }, [initializeDashboard]);

  return (
    <Navigation className="pt-6 h-full flex flex-col">
      <DashboardPageHeader />

      <div className="flex items-start flex-col 2xl:flex-row">
        <DashboardPage />
        <SetupNewWarehouseList />
      </div>
    </Navigation>
  );
};

export default WarehousesPage;
